"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
/* eslint-disable import/no-extraneous-dependencies */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const plds_tokens_1 = require("@paclife/plds.tokens");
const GridOuterContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;

  overflow: hidden;

  /* create margins based on screen size and user input */
  ${({ margins, smMargins }) => {
    const spacing = `${margins * 8}px`;
    const smSpacing = `${smMargins * 8}px`;
    return styled_components_1.css `
      /* for mobile devices */
      padding: 0 ${smSpacing};

      /* for tablet, desktop, and widescreen devices */
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.md}) {
        padding: 0 ${spacing};
      }
    `;
}}
`;
const GridInnerContainer = styled_components_1.default.div `
  box-sizing: border-box;
  width: 100%;

  /* flexbox container properties */
  display: flex;
  align-content: ${({ alignContent }) => alignContent};
  align-items: ${({ alignItems }) => alignItems};
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ justify }) => justify};
  flex-wrap: ${({ wrap }) => wrap};

  /* create gutters based on screen size and user input */
  ${({ gutters, smGutters, xlFluid }) => {
    const spacing = `${gutters * 8}px`;
    const smSpacing = `${smGutters * 8}px`;
    const baseSpacingStyles = styled_components_1.css `
      /* for mobile devices */
      width: calc(100% + ${smSpacing});
      margin-top: -${smSpacing};
      margin-left: -${smSpacing};

      /* for tablet, desktop, and widescreen devices */
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.md}) {
        width: calc(100% + ${spacing});
        margin-top: -${spacing};
        margin-left: -${spacing};
      }

      /* gutter spacing applied to GridItems */
      .item {
        /* for mobile devices */
        padding-top: ${smSpacing};
        padding-left: ${smSpacing};

        /* for tablet, desktop, and widescreen devices */
        @media screen and (min-width: ${plds_tokens_1.MediaQueries.md}) {
          padding-top: ${spacing};
          padding-left: ${spacing};
        }
      }
    `;
    if (xlFluid) {
        return baseSpacingStyles;
    }
    return styled_components_1.css `
      ${baseSpacingStyles}

      /* styling for fixed columns for widescreen devices */
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.xl}) {
        max-width: calc(${plds_tokens_1.MediaQueries.xl} + ${spacing});
      }
    `;
}}
`;
// this is used in GridItem
// this function will be run for each breakpoint
const itemWidthStyleGenerator = (breakpoint) => {
    // default flexbox item behavior
    if (breakpoint === "auto") {
        return styled_components_1.css `
      flex-basis: auto;
      flex-grow: 0;
      max-width: none;
    `;
    }
    // alternative auto layout - item will stretch to fill the container
    if (breakpoint === true) {
        return styled_components_1.css `
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    `;
    }
    if (typeof breakpoint === "number") {
        // determine width of item based on number of columns it spans
        // 12 refers to number of columns
        // width will be precise to 7 significant numbers
        const width = `${Math.round((breakpoint / 12) * 10e7) / 10e5}%`;
        return styled_components_1.css `
      flex-basis: ${width};
      flex-grow: 0;
      max-width: ${width};
    `;
    }
    return undefined;
};
const GridItem = styled_components_1.default.div `
  box-sizing: border-box;
  margin: 0;

  /* determine width of items based on breakpoints */
  ${({ sm }) => itemWidthStyleGenerator(sm)}
  ${({ md }) => styled_components_1.css `
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.md}) {
        ${itemWidthStyleGenerator(md)}
      }
    `}
  ${({ lg }) => styled_components_1.css `
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.lg}) {
        ${itemWidthStyleGenerator(lg)}
      }
    `}
  ${({ xl }) => styled_components_1.css `
      @media screen and (min-width: ${plds_tokens_1.MediaQueries.xl}) {
        ${itemWidthStyleGenerator(xl)}
      }
    `}
`;
function Grid({ alignContent = "stretch", alignItems = "stretch", children, className, component = "div", container = false, direction = "row", gutters = 3, item = false, justify = "flex-start", lg = false, margins = 3, md = false, sm = false, smGutters = 2, smMargins = 2, wrap = "wrap", xl = false, xlFluid = false, }) {
    // note: if user doesn't specify `container` or `item`, we default to `container`
    if (container || !item) {
        return (react_1.default.createElement(GridOuterContainer, { className: className, as: component, margins: margins, smMargins: smMargins },
            react_1.default.createElement(GridInnerContainer, { alignContent: alignContent, alignItems: alignItems, direction: direction, gutters: gutters, justify: justify, smGutters: smGutters, wrap: wrap, xlFluid: xlFluid }, children)));
    }
    return (
    // note that all GridItems have a class name of `item` - this is used for styling purposes
    react_1.default.createElement(GridItem, { className: `${className} item`, as: component, lg: lg, md: md, sm: sm, xl: xl }, children));
}
exports.Grid = Grid;
//# sourceMappingURL=grid.js.map